import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { darkTheme } from "../../../../theme/Theme";
export default function CommonLayout({ children }) {
  const isDarkTheme = useSelector((state) => state.theme);
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "auto",
        flexDirection: "column",
        flex: "1 0 0",
        // gap: "16px",
        background: isDarkTheme
          ? darkTheme.backgroundColorLayer2
          : "var(--color-background-layer-01)",

        boxShadow:
          "var(--Elevation-X-Elevation-04, 4px) var(--Elevation-Y-Elevation-04, 0px) var(--Elevation-Blur-Elevation-04, 24px) var(--Elevation-Spread-Elevation-04, -2px) var(--Elevation-Colors-Elevation-04, rgba(0, 92, 188, 0.08))",
        padding: "24px 24px",
      }}
    >
      {children}
    </Box>
  );
}
